import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container, Typography, useTheme, Divider } from '@mui/material';

const Privacy = () => {
    const theme = useTheme();

    return (
        <Box sx={{
            minHeight: '80vh',
            bgcolor: 'background.default',
            py: { xs: 8, md: 12 },
            position: 'relative',
            overflow: 'hidden'
        }}>
            <Helmet>
                <title>Privacy Policy | WorldWise Scholar</title>
                <link rel="canonical" href="https://worldwisescholar.online/privacy" />
            </Helmet>
            {/* Ambient Glows */}
            <Box sx={{
                position: 'absolute',
                top: '-10%',
                right: '-5%',
                width: '60%',
                height: '60%',
                background: `radial-gradient(circle, ${theme.palette.primary.main}1A 0%, transparent 70%)`,
                zIndex: 0,
                pointerEvents: 'none',
            }} />

            <Container maxWidth="md" sx={{ position: 'relative', zIndex: 1 }}>
                <Typography variant="h2" component="h1" gutterBottom fontWeight="900" sx={{
                    background: theme.palette.mode === 'light'
                        ? 'linear-gradient(to right, #111827, #4F46E5)'
                        : 'linear-gradient(to right, #F8FAFC, #A5B4FC)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    mb: 4
                }}>
                    Privacy Policy
                </Typography>

                <Box sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        1. Introduction
                    </Typography>
                    <Typography paragraph>
                        At WorldWise Scholar, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information when you use our website and services.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        2. Information We Collect
                    </Typography>
                    <Typography paragraph>
                        We may collect personal information such as your name, email address, and educational background when you register for an account, subscribe to our newsletter, or use our scholarship search tools.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        3. How We Use Your Information
                    </Typography>
                    <Typography paragraph>
                        We use your information to provide and improve our services, communicate with you about scholarship opportunities, and personalize your experience on our platform.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        4. Data Security
                    </Typography>
                    <Typography paragraph>
                        We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, disclosure, or destruction.
                    </Typography>

                    <Divider sx={{ my: 4 }} />

                    <Typography variant="h5" gutterBottom color="text.primary" fontWeight="bold">
                        5. Contact Us
                    </Typography>
                    <Typography paragraph>
                        If you have any questions about this Privacy Policy, please contact us at privacy@worldwisescholar.com.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Privacy;
